import { styled } from '@compiled/react';

import { ModalTitle } from '@atlaskit/modal-dialog';
import { token } from '@atlaskit/tokens';

const WRAP_MARGIN = 2;

export const BuildsContainer = styled.div({
  display: 'flex',
  flexFlow: 'column',
  padding: token('space.100'),
});

// Set `min-width: 0` on the flex child in order to support truncating text
// nested within: https://css-tricks.com/flexbox-truncated-text/
export const BuildInfo = styled.div({
  minWidth: 0,
  padding: token('space.025'),
});

export const BuildItem = styled.div({
  display: 'flex',
  alignItems: 'center',
  paddingBottom: token('space.100'),
});

export const BuildName = styled.div({
  display: 'inline-block',
  verticalAlign: 'bottom',
  maxWidth: '100%',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  marginBottom: token('space.050'),
  overflow: 'hidden',
});

export const BuildState = styled.div({
  flex: '0 0 auto',
  marginRight: token('space.100'),
});

export const BuildDescription = styled.small({
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  display: 'block',
  marginTop: `${WRAP_MARGIN}px`,
  '&::after': {
    content: "'\xb7'",
    width: '16px',
    display: 'inline-block',
    textAlign: 'center',
  },
  '&:empty::after': {
    display: 'none',
  },
});

export const BuildTime = styled.small({
  marginTop: `${WRAP_MARGIN}px`,
});

export const BuildDetails = styled.div({
  display: 'flex',
  flexWrap: 'wrap',
  marginTop: `-${WRAP_MARGIN}px`,
});

export const DialogTitle = styled(ModalTitle)({
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',
});
export const DialogContainer = styled.div({
  paddingBottom: '14px',
  overflow: 'hidden auto',
});
